var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.053,
    height: 10.883,
    viewBox: "0 0 19.053 10.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(-620.5 -1451.067)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_136",
    "data-name": "Ligne 136",
    x2: 18,
    transform: "translate(620.5 1456.5)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1279",
    "data-name": "Trac\\xE9 1279",
    d: "M633.81,1450.386c.787.455,5.048,5.048,5.048,5.048l-5.048,5.048",
    transform: "translate(0 1.114)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.717c9f5c6eb428b2b30cabf8575dd35d.svg";
export { ForwardRef as ReactComponent };